import SkinProducts from '../components/SkinProducts/SkinProducts';
import FaceProducts from '../components/FaceProducts/FaceProducts';
import Glowing from '../components/Glowing/Glowing';

const ProductPage = () => {
	return (
		<>
			<SkinProducts />
			<FaceProducts />
			<Glowing />
		</>
	)
}

export default ProductPage